<h3 mat-dialog-title>{{ 'filters' | translate }}</h3>
<div mat-dialog-content>
  <app-filter-builder #filterBuilder></app-filter-builder>
</div>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
  <button mat-button (click)="filter()">{{ 'filter' | translate }}</button>
</mat-dialog-actions>